<template>
  <v-menu offset-y left>
    <template #activator="{ on, attrs }">
      <v-btn dark icon v-bind="attrs" v-on="on">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <v-card class="py-3">
      <div
        v-if="
          hasAnyPermission([
            'ASSIGNMENT_CREATE',
            'ASSIGNMENT_DELETE',
            'MEMBERSHIP_CREATE',
            'MEMBERSHIP_DELETE'
          ])
        "
      >
        <v-subheader>Manage</v-subheader>
        <v-list class="py-0">
          <v-list-item
            v-if="hasAnyPermission(['MEMBERSHIP_CREATE', 'MEMBERSHIP_DELETE'])"
            class="v-list-item--link px-3"
            exact
            :href="typeof manageUsersLink === 'string' ? manageUsersLink : undefined"
            :to="typeof manageUsersLink === 'string' ? undefined : manageUsersLink"
            >Users</v-list-item
          >
        </v-list>
        <v-divider />
      </div>
      <v-subheader>Support</v-subheader>
      <v-list class="py-0">
        <v-list-item
          class="v-list-item--link px-3"
          href="https://idm.deeplens.systems/auth/realms/DeepLens/protocol/saml/clients/zendesk"
          target="_blank"
          >Help Center<v-icon small class="pl-1">launch</v-icon></v-list-item
        >
      </v-list>
      <v-divider />
      <v-subheader>Legal</v-subheader>
      <v-list class="py-0">
        <v-list-item class="v-list-item--link px-3" exact :to="{ name: 'terms' }"
          >Terms & Conditions</v-list-item
        >
        <v-list-item class="v-list-item--link px-3" exact :to="{ name: 'privacy' }"
          >Privacy Policy</v-list-item
        >
      </v-list>
      <div class="pt-3">
        <p class="caption grey--text mb-0 px-3">&copy; {{ year }} Paradigm Health, Inc.</p>
        <p class="caption grey--text mb-0 px-3">Not for primary diagnostic use</p>
        <p class="caption mb-0 px-3">
          <router-link class="grey--text " :to="{ name: 'version' }">{{ appVersion }}</router-link>
        </p>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { permissionsMixin } from '@/mixins/permissions'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import moment from 'moment'
import { isFeatureOn } from '@/helpers/feature-flag-helper'

export default {
  mixins: [permissionsMixin],
  data() {
    return {
      orgId: MyActiveOrganization.id,
      year: moment().format('YYYY')
    }
  },
  computed: {
    appVersion() {
      return process.env.VERSION
    },
    manageUsersLink() {
      if (isFeatureOn('viper-platform-ui-react-manage-users-page')) {
        return `${window.$appConfig.VUE_APP_PLATFORM_UI_URL}/org/${this.orgId}/manage/users`
      }
      return { name: 'manage-users', params: { orgId: this.orgId } }
    }
  }
}
</script>
